import axios from "../../http";
import {
  INSTAGRAM_PHOTO_LIST_REQUEST,
  INSTAGRAM_PHOTO_LIST_SUCCESS,
  INSTAGRAM_PHOTO_LIST_FAIL,
} from "../Constants/InstagramPhotoConstants";

export const listStoreInstagramPhotos = () => async (dispatch) => {
  try {
    dispatch({ type: INSTAGRAM_PHOTO_LIST_REQUEST });
    const { data } = await axios.get("/api/instagram-photos/store", {
      params: { t: Date.now() },
      headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
    });

    const photos = Array.isArray(data)
      ? data
      : Array.isArray(data?.photos)
      ? data.photos
      : [];

    dispatch({ type: INSTAGRAM_PHOTO_LIST_SUCCESS, payload: photos });
  } catch (error) {
    dispatch({
      type: INSTAGRAM_PHOTO_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};